<div class="navbar-item font-standard has-dropdown mr-2" [class.is-active]="langMenu" style="width: fit-content">
  <a class="navbar-link font-standard" (click)="toggleLangMenu()">
    <fa-icon [icon]="faGlobe"></fa-icon>&nbsp; {{ language().toUpperCase() }}
  </a>
  @if (langMenu) {
  <div class="navbar-dropdown">
    <a class="navbar-item font-standard" [class.is-active]="language() === 'en'" (click)="setLanguage('EN')">English</a>
    <a class="navbar-item font-standard" [class.is-active]="language() === 'no'" (click)="setLanguage('NO')">Norsk</a>
    <a class="navbar-item font-standard" [class.is-active]="language() === 'es'" (click)="setLanguage('ES')">Español</a>
    <a class="navbar-item font-standard" [class.is-active]="language() === 'se'" (click)="setLanguage('SE')">Svenska</a>
    <a class="navbar-item font-standard" [class.is-active]="language() === 'fr'" (click)="setLanguage('FR')"
      >Français</a
    >
    <a class="navbar-item font-standard" [class.is-active]="language() === 'de'" (click)="setLanguage('DE')">Deutsch</a>
    <a class="navbar-item font-standard" [class.is-active]="language() === 'da'" (click)="setLanguage('DA')">Dansk</a>
    <a class="navbar-item font-standard" [class.is-active]="language() === 'nl'" (click)="setLanguage('NL')">Dutch</a>
  </div>
  }
</div>
